import { FullReportDay } from './types';

export const getFullReportDayId = (entry: Pick<FullReportDay, 'id' | 'date'>) =>
  entry.id != null ? String(entry.id) : entry.date;
